import React, { useState, useEffect, useMemo, useRef } from "react";
import ApiConfig from "../common/config/ApiConfig";
import { useCurrency } from "../common/CurrencyContext";
import Lottotype from "./lottotype";
import { motion } from "framer-motion";
import "./numadd.css";
// import ToggleButton from './orders'
import { v4 as uuidv4 } from "uuid";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { SWAL_THEME } from "../common/utils/swalTheme";
import DescriptionIcon from "@mui/icons-material/Description";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Dialog from "@mui/material/Dialog";
import CircularProgress from "@mui/material/CircularProgress";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Lottotypeformodal from "../Modals/lottotypemodal";
import useMediaQuery from "@mui/material/useMediaQuery";
import CloseIcon from "@mui/icons-material/Close";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { Link } from "react-router-dom";
import ManualOrder from "./order/manualOrder";
import PanelOrder from "./order/panelOrder";
import StepModal from "./order/stepModal";
import { useTranslation } from "react-i18next";

function Numadd(props) {
  const currency = useCurrency();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const lottoTypeId = location.state?.id;

  // Single source of truth for the current lotto type's bet-type groups,
  // shared between the betting logic below and ManualOrder's display.
  const [rewardTypeGroups, setRewardTypeGroups] = useState([]);

  useEffect(() => {
    ApiConfig.post("/getLottoRewardTypeGroupsOpen", { lottoTypeId }).then(
      (res) => {
        if (res.resCode === 200) {
          setRewardTypeGroups(res.data);
        }
      },
    );
  }, [lottoTypeId]);

  // code -> { stake, digit }. `digit` (how many digits to collect before
  // this code becomes a bet) comes from the reward type itself;
  // "words"-stake codes have no digits and are added to the bet list
  // immediately.
  const codeMeta = useMemo(() => {
    const meta = {};
    rewardTypeGroups.forEach((group) => {
      group.rewardTypes.forEach((rewardType) => {
        meta[rewardType.code] = {
          stake: rewardType.stake,
          digit: rewardType.digit,
          name: rewardType.name,
        };
      });
    });
    return meta;
  }, [rewardTypeGroups]);

  const [open, setOpen] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [inputType, setInputType] = useState([]);
  const [allbetamt, setAllbetamt] = useState(0);
  const [history, setHistory] = useState(1);
  // Price typed in before picking a number — becomes every new bet's
  // starting bet_amout (replacing the old hardcoded 1), so the user can
  // set it once instead of bulk-editing every entry afterward via
  // handlecalbutton/handlecalbuttonfixprice.
  const [betPrice, setBetPrice] = useState(10);

  const [number1, setNumber1] = useState("");
  const [number2, setNumber2] = useState("");
  const [number3, setNumber3] = useState("");
  const [number4, setNumber4] = useState("");
  const [number5, setNumber5] = useState("");
  const [number6, setNumber6] = useState("");

  // Each lotto type keeps its own separate queued bet list — otherwise
  // switching types (this component stays mounted across a switch, same as
  // the payrate/limit effects below that key off props.type) would show
  // e.g. th_gov's queued numbers mixed in with laos_gov's.
  const [array, setArrayRaw] = useState(() => {
    try {
      const saved = localStorage.getItem(`lottotype_array_${props.type}`);
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });
  // Drop any entry whose payout rate isn't a positive number so a bet
  // never gets added (or stays) with an undefined/zero payrate. Reuses
  // nextArray's own reference when nothing was dropped, since some effects
  // pass the same array back in and rely on reference equality to bail out
  // (filter() always allocates a new array, which would otherwise retrigger
  // them every render and loop forever).
  function setArray(nextArray) {
    const filtered = nextArray.filter((item) => {
      const rate = parseFloat(item.bet_payrate);
      return !isNaN(rate) && rate > 0;
    });
    if (filtered.length !== nextArray.length) {
      toast.error(t("numadd.toast.noPayrate"), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      setArrayRaw(filtered);
      return;
    }
    setArrayRaw(nextArray);
  }
  const [numpadvisible, setNumpadvisible] = useState(true);
  const [garr, setgrr] = useState(() => {
    try {
      const saved = localStorage.getItem(`lottotype_garr_${props.type}`);
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });
  // Guards the persistence effects below against saving the OLD type's
  // array/garr into the NEW type's storage key the instant props.type
  // changes — react runs effects in declaration order within one commit, so
  // the reload effect (which sets these) runs before the save effects see
  // the type change, but `array`/`garr` themselves haven't been replaced
  // yet in that same commit (setArrayRaw/setgrr only take effect next
  // render). Each flag is consumed (reset to false) by its own save effect.
  const skipArraySaveRef = useRef(false);
  const skipGarrSaveRef = useRef(false);

  // Push a typed digit into the active code's window (number1..numberN):
  // the newest digit always lands in the last slot of the window, and
  // earlier digits shift toward number1 so they end up in typed order.
  const handleNumpad = (e) => {
    const value = e.target.value;
    const activeCode = inputType.find(
      (code) => codeMeta[code]?.stake === "number",
    );
    if (!activeCode) return;
    const digitCount = codeMeta[activeCode].digit;
    if (!digitCount) return;

    const current = [number1, number2, number3, number4, number5, number6];
    const window = current.slice(0, digitCount);
    const shifted = [...window.slice(1), value];
    const next = [...shifted, ...current.slice(digitCount)];

    setNumber1(next[0]);
    setNumber2(next[1]);
    setNumber3(next[2]);
    setNumber4(next[3]);
    setNumber5(next[4]);
    setNumber6(next[5]);
  };

  // Undo the last digit press: shift the active code's digit window
  // (number1..numberN) right by one, dropping the most recent digit.
  const handleundo = () => {
    const activeCode = inputType.find(
      (code) => codeMeta[code]?.stake === "number",
    );
    if (!activeCode) return;
    const digitCount = codeMeta[activeCode].digit;
    if (!digitCount) return;

    const current = [number1, number2, number3, number4, number5, number6];
    const window = current.slice(0, digitCount);
    const unshifted = ["", ...window.slice(0, digitCount - 1)];
    const next = [...unshifted, ...current.slice(digitCount)];

    setNumber1(next[0]);
    setNumber2(next[1]);
    setNumber3(next[2]);
    setNumber4(next[3]);
    setNumber5(next[4]);
    setNumber6(next[5]);
  };

  // A "step" code (e.g. big/small/odd/even per position) is configured
  // via a modal instead of the numpad; this holds which code the modal
  // is currently open for.
  const [stepModalCode, setStepModalCode] = useState(null);

  const handleStepConfirm = (selection) => {
    const code = stepModalCode;
    const newEntry = {
      id: uuidv4(),
      history: history,
      number: selection,
      bet_amout: betPrice,
      bet_payrate: getRate(code),
      bet_type: code,
    };
    setArray([...array, newEntry]);
    setHistory(history + 1);
    setStepModalCode(null);
  };

  // handle Type
  // A "number"-stake code needs digits typed in before it becomes a bet;
  // a "words"-stake code has no number at all, so selecting it adds the
  // bet immediately with number "@". A "step"-stake code opens a modal to
  // pick big/small/odd/even per position. Selecting a "number" code keeps
  // only the other currently-selected codes that need the same digit
  // count (codes needing a different digit count can't be entered
  // together).
  const handleType = (event) => {
    // currentTarget (the <button value=...>), not target — a click can
    // land on a child element inside the button (the icon, the label
    // text, the rate badge span), which has no `value` of its own and
    // would silently no-op below.
    const code = event.currentTarget.value;
    const meta = codeMeta[code];
    if (!meta) return;

    if (meta.stake === "words") {
      const newEntry = {
        id: uuidv4(),
        history: history,
        number: "@",
        bet_amout: betPrice,
        bet_payrate: getRate(code),
        bet_type: code,
      };
      setArray([...array, newEntry]);
      setHistory(history + 1);
      return;
    }

    if (meta.stake === "step" || meta.stake === "mix") {
      setStepModalCode(code);
      return;
    }

    if (inputType.includes(code)) {
      setInputType(inputType.filter((item) => item !== code));
    } else {
      const sameDigitGroup = inputType.filter(
        (item) => codeMeta[item]?.digit === meta.digit,
      );
      setInputType([...sameDigitGroup, code]);
    }

    setNumber1("");
    setNumber2("");
    setNumber3("");
    setNumber4("");
    setNumber5("");
    setNumber6("");
    setNumpadvisible(true);
  };

  // Once the active code's digit window is fully typed (number1 is always
  // the last slot to fill, regardless of digit count), push one bet entry
  // per currently-selected "number"-stake code using those digits.
  useEffect(() => {
    if (number1 === "") return;

    const activeCode = inputType.find(
      (code) => codeMeta[code]?.stake === "number",
    );
    if (!activeCode) return;

    const digitCount = codeMeta[activeCode].digit;
    if (!digitCount) return;

    const combined = [number1, number2, number3, number4, number5, number6]
      .slice(0, digitCount)
      .join("");

    const entries = inputType
      .filter((code) => codeMeta[code]?.stake === "number")
      .map((code) => ({
        id: uuidv4(),
        history: history,
        number: combined,
        bet_amout: betPrice,
        bet_payrate: getRate(code),
        bet_type: code,
      }));

    setArray([...array, ...entries]);
    setHistory(history + 1);

    setNumber1("");
    setNumber2("");
    setNumber3("");
    setNumber4("");
    setNumber5("");
    setNumber6("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [number1]);

  const handleDelete = (id) => {
    const deletVal = [...array];
    let tempExpenses = deletVal.filter((item) => item.id !== id);
    setArray(tempExpenses);
  };

  // handle change bet_amout
  const handleChange = (e, id) => {
    const inputdata = [...array];
    const itemToUpdate = inputdata.find((item) => item.id === id);
    // Strip thousands-separator commas (the input displays e.g. "1,000")
    // before parsing, otherwise parseInt stops at the first comma and
    // silently truncates the value (e.g. "1,000" -> 1).
    const rawValue = e.target.value.replace(/,/g, "");
    const newData = { bet_amout: parseInt(rawValue) };
    const type = itemToUpdate.bet_type;

    // Convert the input value to a number or set it to 0 if blank
    const parsedValue = rawValue.trim() !== "" ? parseInt(rawValue) : 0;

    if (parsedValue > parseInt(maxbet[type])) {
      newData.bet_amout = parseInt(maxbet[type]);
    } else if (parsedValue < parseInt(minbet[type])) {
      newData.bet_amout = parseInt(minbet[type]);
    } else {
      newData.bet_amout = parsedValue;
    }

    itemToUpdate.bet_amout = newData.bet_amout;
    Object.assign(itemToUpdate, newData);
    setArray(inputdata);
  };

  // handle cal
  const handlecal = (e) => {
    const value = e.target.value;
    setAllbetamt(value);
  };
  const handlecalbutton = () => {
    const arr = [...array];
    const parsedAllbetamt = parseInt(allbetamt);
    for (let i = 0; i < arr.length; i++) {
      if (isNaN(parsedAllbetamt)) {
        arr[i].bet_amout = 0;
      } else if (parsedAllbetamt > parseInt(maxbet[arr[i].bet_type])) {
        arr[i].bet_amout = parseInt(maxbet[arr[i].bet_type]);
      } else {
        arr[i].bet_amout = parsedAllbetamt;
      }
    }
    setArray(arr);
    setAllbetamt(0);
  };

  const handlecalbuttonfixprice = (bet) => {
    const arr = [...array];
    const parsedBet = parseInt(bet);
    const defaultBetValue = 0;

    for (let i = 0; i < arr.length; i++) {
      if (isNaN(parsedBet) || parsedBet === 0) {
        // Check for NaN or 0
        arr[i].bet_amout = defaultBetValue;
      } else if (parsedBet > parseInt(maxbet[arr[i].bet_type])) {
        arr[i].bet_amout = parseInt(maxbet[arr[i].bet_type]);
      } else if (parsedBet < parseInt(minbet[arr[i].bet_type])) {
        arr[i].bet_amout = parseInt(minbet[arr[i].bet_type]);
      } else {
        arr[i].bet_amout = parsedBet;
      }
    }

    setArray(arr);
  };

  const user = localStorage.getItem("user");

  function calculateItemSums() {
    const itemSums = array.reduce((acc, currentItem) => {
      acc[currentItem.bet_type] =
        (acc[currentItem.bet_type] || 0) + currentItem.bet_amout;
      return acc;
    }, {});
    return itemSums;
  }

  function checkPricesAgainstMax() {
    const itemSums = calculateItemSums();
    for (const [item, sum] of Object.entries(itemSums)) {
      if (sum > maxbetpermatch[item]) {
        let message;
        if (item === "first") {
          message = t("numadd.betTypes.first");
        } else if (item === "four_top") {
          message = t("numadd.betTypes.fourTop");
        } else if (item === "four_tod") {
          message = t("numadd.betTypes.fourTod");
        } else if (item === "three_top") {
          message = t("numadd.betTypes.threeTop");
        } else if (item === "three_front") {
          message = t("numadd.betTypes.threeFront");
        } else if (item === "three_bot") {
          message = t("numadd.betTypes.threeBot");
        } else if (item === "three_tod") {
          message = t("numadd.betTypes.threeTod");
        } else if (item === "two_top") {
          message = t("numadd.betTypes.twoTop");
        } else if (item === "two_bot") {
          message = t("numadd.betTypes.twoBot");
        } else if (item === "run_top") {
          message = t("numadd.betTypes.runTop");
        } else if (item === "run_bot") {
          message = t("numadd.betTypes.runBot");
        }

        toast.error(
          t("numadd.toast.maxBetExceeded", {
            item: message,
            max: maxbetpermatch[item],
          }),
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          },
        );

        return false; // If any item exceeds the max price or has no max price defined
      }
    }
    return true; // All items are within their respective maximum prices
  }

  function checkzeropayrate() {
    if (array.some((item) => item.bet_payrate === 0)) {
      toast.error(t("numadd.toast.zeroPayrate"), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return false;
    }

    return true;
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    setOpen(false);
    const jsonData = {
      username: user,
      type: props.type,
      round: props.round,
      status: "wait_result",
      resultdate: new Date().toISOString().slice(0, 10),
      array: array,
    };
    const totalPrice = array.reduce((sum, item) => sum + item.bet_amout, 0);
    if (array.length !== 0) {
      if (props.balance >= totalPrice) {
        if (checkPricesAgainstMax() && checkzeropayrate()) {
          Swal.fire({
            ...SWAL_THEME,
            title: t("numadd.confirmSubmit.title"),
            text: t("numadd.confirmSubmit.text"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: t("numadd.confirmSubmit.confirmButton"),
            cancelButtonText: t("numadd.confirmSubmit.cancelButton"),
          }).then((result) => {
            if (result.isConfirmed) {
              setSubmitLoading(true);
              ApiConfig.post("/orders", jsonData)
                .then((result) => {
                  // Toastify success notification
                  if (result.resCode === 200) {
                    setArray([]);
                    setgrr([]);
                    localStorage.removeItem("lottotype_array");
                    localStorage.removeItem("lottotype_garr");
                    toast.success(t("numadd.toast.submitSuccess"), {
                      position: "top-right",
                      autoClose: 2000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                      theme: "colored",
                    });
                    setTimeout(() => {
                      // Reload the page
                      window.location = "/dashboard/orderlist";
                    }, 1000); // Delay for 5 seconds
                  } else {
                    setSubmitLoading(false);
                    setOpen(true);
                    toast.error(
                      result.message || t("numadd.toast.submitFailed"),
                      {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                      },
                    );
                  }
                })
                .catch((error) => {
                  console.error("Error:", error);
                  setSubmitLoading(false);
                  setOpen(true);
                  toast.error(t("numadd.toast.submitError"), {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                  });
                });
            } else {
              Swal.fire(
                t("numadd.cancelledSubmit.title"),
                t("numadd.cancelledSubmit.text"),
                "error",
              );
              setOpen(true);
            }
          });
        } else {
        }
      } else {
        toast.error(t("numadd.toast.insufficientCredit"), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } else {
      toast.error(t("numadd.toast.selectNumbersFirst"), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const [payrate, setPayrate] = useState([]);

  // /Getmemberpayrate returns one row per bet-type code:
  // { lotto_type, stake: "three_top", payrate: "700.00", ... }
  function getRate(code) {
    const row = payrate.find((item) => item.stake === code);
    return row ? row.payrate : undefined;
  }

  const [limitnumber, setLimitnumber] = useState([]);
  const [maxbet, setMaxbet] = useState([]);
  const [maxbetpermatch, setMaxbetpermatch] = useState([]);
  const [minbet, setMinbet] = useState([]);

  const Payrateget = () => {
    const jsonData = {
      memberuser: localStorage.getItem("user"),
    };

    ApiConfig.post("/Getmemberpayrate", jsonData).then((res) => {
      if (res.resCode === 200) {
        const result = res.data;
        const filtered = result.filter(
          (item) => item.lotto_type === props.type,
        );
        setPayrate(filtered);
        return;
      }
      if (res.resCode === 422) {
        toast.error(t("numadd.toast.commissionNotSet"), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        navigate(-1);
      }
    });
  };

  const Limitnumberget = () => {
    const jsonData = {
      lotto_type: props.type,
      res_date: props.resultdate,
      round: props.round,
      memberuser: localStorage.getItem("user"),
    };

    ApiConfig.post("/getlimitnumberformember", jsonData).then((result) => {
      if (result.resCode === 200) setLimitnumber(result.data);
    });
  };

  const maxbetget = () => {
    const jsonData = {
      lottotype: props.type,
      memberuser: localStorage.getItem("user"),
    };

    ApiConfig.post("/getmaxbetformember", jsonData).then((result) => {
      if (result.resCode === 200) setMaxbet(result.data[0]);
    });
  };

  const maxbetpermatchget = () => {
    const jsonData = {
      lottotype: props.type,
      memberuser: localStorage.getItem("user"),
    };

    ApiConfig.post("/getmaxbetpermatchformember", jsonData).then((result) => {
      if (result.resCode === 200) setMaxbetpermatch(result.data[0]);
    });
  };

  const minbetget = () => {
    const params = new URLSearchParams({
      lottotype: props.type,
      memberuser: localStorage.getItem("user"),
    });

    ApiConfig.get(`/getminbetformember?${params.toString()}`).then((result) => {
      if (result.resCode === 200) setMinbet(result.data[0]);
    });
  };

  useEffect(() => {
    Payrateget();
    Limitnumberget();
    maxbetget();
    minbetget();
    maxbetpermatchget();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.type, props.resultdate, props.round]);

  useEffect(() => {
    const array1 = array;
    const array2 = limitnumber;

    array1.forEach((item1) => {
      const item2 = array2.find(
        (i) => i.number === item1.number && i.number_type === item1.bet_type,
      );
      if (item2) {
        item1.bet_payrate = item2.limit_payrate;
      }
    });

    setArray(array1);
    // Newest entry first within each bet_type group, and the groups
    // themselves ordered by their most recent entry (walking `array`
    // newest-to-oldest, a type's key is created the first time it's seen),
    // so the list the member sees grows downward from the top instead of
    // the bottom — `array` itself stays in original (oldest-first) order
    // since other logic (submission, undo-latest by `history`) doesn't
    // depend on this.
    const GroupArray = {};
    for (let i = array.length - 1; i >= 0; i--) {
      const item = array[i];
      (GroupArray[item.bet_type] = GroupArray[item.bet_type] || []).push(item);
    }
    setgrr(GroupArray);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [array, limitnumber]);

  // Swaps the in-memory bet list/grouping for the newly-selected type's own
  // saved copies whenever props.type changes (also fires harmlessly on
  // mount, redundantly re-loading what the lazy initializers above already
  // set — the skip flags below just no-op on that first save either way).
  useEffect(() => {
    skipArraySaveRef.current = true;
    skipGarrSaveRef.current = true;
    try {
      const savedArray = localStorage.getItem(`lottotype_array_${props.type}`);
      setArrayRaw(savedArray ? JSON.parse(savedArray) : []);
    } catch {
      setArrayRaw([]);
    }
    try {
      const savedGarr = localStorage.getItem(`lottotype_garr_${props.type}`);
      setgrr(savedGarr ? JSON.parse(savedGarr) : []);
    } catch {
      setgrr([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.type]);

  useEffect(() => {
    if (skipGarrSaveRef.current) {
      skipGarrSaveRef.current = false;
      return;
    }
    localStorage.setItem(`lottotype_garr_${props.type}`, JSON.stringify(garr));
  }, [garr, props.type]);

  useEffect(() => {
    if (skipArraySaveRef.current) {
      skipArraySaveRef.current = false;
      return;
    }
    localStorage.setItem(
      `lottotype_array_${props.type}`,
      JSON.stringify(array),
    );
  }, [array, props.type]);

  const [selecttype, setSelecttype] = useState("numpad");
  const [, setModal] = useState("");
  const [, setShowModal] = useState(false);
  const [confirmClear, setConfirmClear] = useState(false);

  // Checkbox variant of the number picker (panelOrder.jsx's selectnum) — a
  // number stays checked for as long as it's actually in `array`, so a
  // second click on the same number removes it rather than stacking a
  // duplicate bet (this replaced the old handleClick, which only ever
  // added one more entry per click and never removed anything). One set of
  // functions generalized over every digit length (1: run_top/run_bot, 2:
  // two_top/two_bot, 3: three_top/three_front/three_bot/three_tod, 4:
  // four_top/four_tod) instead of one per length.
  const STAKE_CODES_BY_DIGIT = {
    1: ["run_top", "run_bot"],
    2: ["two_top", "two_bot"],
    3: ["three_top", "three_front", "three_bot", "three_tod"],
    4: ["four_top", "four_tod"],
  };

  // Currently-active stake codes for one digit length (0-4 of that
  // length's codes, depending on which RewardTypeButtons are toggled on).
  const activeCodesForDigit = (digit) =>
    (STAKE_CODES_BY_DIGIT[digit] || []).filter((code) =>
      inputType.includes(code),
    );

  const buildEntriesForNumber = (numberStr, digit) =>
    activeCodesForDigit(digit).map((code) => ({
      id: uuidv4(),
      number: numberStr,
      bet_amout: betPrice,
      bet_payrate: getRate(code),
      bet_type: code,
    }));

  // A number counts as "checked" only once EVERY currently-active stake of
  // this digit length has an entry for it — so toggling it always adds/
  // removes as one atomic action across all of them when several are
  // selected at once, rather than leaving a partially-checked state.
  const isNumberSelected = (numberStr, digit) => {
    const codes = activeCodesForDigit(digit);
    if (codes.length === 0) return false;
    return codes.every((code) =>
      array.some(
        (item) => item.number === numberStr && item.bet_type === code,
      ),
    );
  };

  const handleNumberToggle = (numberStr, digit) => {
    const codes = activeCodesForDigit(digit);
    if (codes.length === 0) return;
    if (isNumberSelected(numberStr, digit)) {
      setArray(
        array.filter(
          (item) =>
            !(item.number === numberStr && codes.includes(item.bet_type)),
        ),
      );
      return;
    }
    setArray([...array, ...buildEntriesForNumber(numberStr, digit)]);
    setModal(numberStr);
    setShowModal(true);
    setTimeout(() => setShowModal(false), 300);
  };

  // Bulk row/column/select-all toggle: if every number in the group is
  // already checked, unchecking removes all of them; otherwise only the
  // not-yet-checked numbers in the group are added — built as ONE setArray
  // call (not one call per number) since array-based state updates built
  // off the stale `array` closure would otherwise silently overwrite each
  // other inside a loop.
  const handleNumberGroupToggle = (numbers, digit) => {
    const codes = activeCodesForDigit(digit);
    if (codes.length === 0) return;
    const allSelected = numbers.every((n) => isNumberSelected(n, digit));
    if (allSelected) {
      setArray(
        array.filter(
          (item) =>
            !(numbers.includes(item.number) && codes.includes(item.bet_type)),
        ),
      );
      return;
    }
    const newEntries = numbers
      .filter((n) => !isNumberSelected(n, digit))
      .flatMap((n) => buildEntriesForNumber(n, digit));
    setArray([...array, ...newEntries]);
  };

  function setArrayZe() {
    setArray([]);
    localStorage.removeItem("lottotype_garr");
    localStorage.removeItem("lottotype_array");
  }

  const [numset, setNumset] = useState("0");
  const firstnumset = (e) => {
    setNumset(e.target.value);
  };
  // 4-digit stakes (four_top/four_tod) need a SECOND fixed digit — first +
  // second digit narrows 10,000 numbers down to the same 100-number, 2-axis
  // grid 2-digit and 3-digit stakes already use (see panelOrder.jsx).
  const [numset2, setNumset2] = useState("0");
  const secondnumset = (e) => {
    setNumset2(e.target.value);
  };

  const initialValue = 0;
  const sumWithInitial = array.reduce(
    (accumulator, currentValue) =>
      accumulator + parseInt(currentValue.bet_amout),
    initialValue,
  );
  const isMobile = useMediaQuery("(max-width: 768px)");

  function deleteLatestHistory() {
    let latestHistory = 0;
    let updatearray = [...array];

    // Find the latest history value
    updatearray.forEach((item) => {
      if (item.history > latestHistory) {
        latestHistory = item.history;
      }
    });

    if (latestHistory !== 0) {
      // Remove all entries with the latest history value
      updatearray = updatearray.filter(
        (item) => item.history !== latestHistory,
      );
      setArray(updatearray); // Update the state with the modified array
    }
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      style={{ display: "flex", flexDirection: "column" }}
    >
      {submitLoading && (
        <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-3 bg-black/60">
          <CircularProgress sx={{ color: "#fff" }} />
          <span className="text-white font-semibold text-sm">
            {t("numadd.submittingOrder")}
          </span>
        </div>
      )}
      <div className="flex flex-col justify-center">
        <div className="w-[100%] flex flex-row h-[44px] p-2 justify-center items-center bg-gradient-to-r from-brand-blue-800 via-brand-blue-700 to-brand-blue-800 border-b border-brand-gold-300/40 space-x-2 rounded-t-lg shadow-card">
          <Link
            to="/dashboard"
            className="md:w-[5%] text-center bg-brand-blue-900/70 border border-brand-gold-300/60 rounded-full justify-center shadow-md flex justify-center hover:bg-brand-blue-900 transition-colors px-2"
          >
            <span className="text-brand-gold-200 font-bold">
              {t("numadd.back")}
            </span>
          </Link>
          <span className="text-white font-bold text-m"></span>
          <div className="md:w-[20%] text-center bg-white/95 rounded-full place-content-center shadow-sm flex justify-center px-2">
            <span className="text-brand-blue-700 font-bold">
              <span className="text-slate-700 font-bold text-m">
                {t("numadd.betLabel")}
              </span>
              {props.type === "th_gov" && t("numadd.types.thGov")}
              {props.type === "hanoy_PhuQua" && t("numadd.types.hanoi")}
              {props.type === "laos_gov" && t("numadd.types.laos")}
              {props.type === "Yeekee_5" && t("numadd.types.yeekeeNormal")}
              {props.type === "Yeekee_10" && t("numadd.types.yeekeeVip")}
              {props.type === "Yeekee_15" && t("numadd.types.yeekeeVvip")}
            </span>
          </div>
        </div>
        <div className="flex flex-row bg-gradient-to-r from-brand-blue-800 from-30% via-brand-blue-700 via-50% to-brand-blue-900 to-90% border-[1px] border-brand-gold-300/30 w-[100%] h-[auto] md:h-[700px] drop-shadow-2xl">
          <div className="flex_type md:h-full md:min-h-0">
            <div className="flex flex-col p-1 space-y-2 w-[30%] bg-brand-blue-900 h-auto md:h-full md:min-h-0">
              <div className="flex flex-col space-y-2 w-[100%] md:h-full md:min-h-0">
                <div className="w-[100%] border-b-[1px] border-slate-700 p-1 space-y-2">
                  <span className="font-bold text-brand-gold-300 md:text-lg text-[0.6rem] flex items-center gap-1">
                    <DescriptionIcon fontSize="small" />
                    {t("numadd.betListCount", { count: array.length })}
                  </span>
                  <button
                    onClick={handleClickOpen}
                    disabled={garr.length === 0}
                    className="bg-gradient-to-b from-brand-gold-300 to-brand-gold-600 hover:from-brand-gold-200 hover:to-brand-gold-500 w-[100%] rounded-lg text-[16px] font-semibold text-brand-ink-onGold shadow-gold flex items-center justify-center gap-1 py-1.5 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <AttachMoneyIcon fontSize="small" /> {t("numadd.setPrice")}
                  </button>

                  <Dialog
                    open={confirmClear}
                    onClose={() => setConfirmClear(false)}
                    maxWidth="xs"
                    fullWidth
                  >
                    <DialogTitle className="relative overflow-hidden flex items-center gap-2 bg-gradient-to-r from-brand-blue-900 via-brand-blue-800 to-brand-blue-900 border-b-2 border-brand-gold-300">
                      <span
                        aria-hidden="true"
                        className="pointer-events-none absolute top-[-40%] bottom-[-40%] left-[-28%] w-[22%] bg-gradient-to-r from-transparent via-white/40 to-transparent -skew-x-[18deg] animate-header-sheen"
                      />
                      <WarningAmberIcon className="text-brand-gold-300" />
                      <span className="text-brand-gold-200 font-bold font-heading">
                        {t("numadd.confirmClearTitle")}
                      </span>
                    </DialogTitle>
                    <DialogContent
                      dividers
                      className="bg-gradient-to-br from-brand-blue-900 via-brand-blue-800 to-brand-blue-900 border-brand-blue-700"
                    >
                      <span className="text-brand-gold-100">
                        {t("numadd.confirmClearBody")}
                      </span>
                    </DialogContent>
                    <DialogActions className="bg-brand-blue-900">
                      <button
                        className="px-4 py-1.5 rounded-pill border border-brand-gold-300/50 text-brand-gold-200 hover:bg-brand-blue-800 transition-colors"
                        onClick={() => setConfirmClear(false)}
                      >
                        {t("numadd.cancel")}
                      </button>
                      <button
                        className="relative px-4 py-1.5 rounded-pill bg-gradient-to-r from-rose-600 to-red-700 hover:from-rose-700 hover:to-red-800 border border-brand-gold-300 text-brand-gold-100 font-bold shadow-md transition-all"
                        onClick={() => {
                          setArrayZe();
                          setConfirmClear(false);
                        }}
                      >
                        <span
                          aria-hidden="true"
                          className="pointer-events-none absolute -inset-0.5 rounded-pill border-2 border-brand-gold-300 animate-cta-pulse-ring"
                        />
                        {t("numadd.clearAll")}
                      </button>
                    </DialogActions>
                  </Dialog>

                  <Dialog
                    open={open}
                    onClose={handleClose}
                    maxWidth="sm"
                    fullWidth={true}
                    fullScreen={isMobile ? true : false}
                  >
                    <DialogTitle className="flex text-center bg-brand-blue-800 h-auto">
                      <span className="text-brand-gold-200 text-[20px]">
                        {t("numadd.setPrice")}
                      </span>
                      <button onClick={handleClose} className="ml-auto">
                        <CloseIcon></CloseIcon>
                      </button>
                    </DialogTitle>
                    <DialogContent sx={{ padding: 0 }}>
                      <div className="h-[100%] flex flex-col">
                        <Lottotypeformodal
                          grouparray={garr}
                          codeMeta={codeMeta}
                          handleDelete={handleDelete}
                          handleChange={handleChange}
                        />
                      </div>
                    </DialogContent>
                    <DialogActions className="bg-slate-50 flex flex-col">
                      <div className="w-[100%] flex flex-col">
                        <div className="flex rounded border-[1px] border-black md:p-3 flex-row w-[100%]">
                          <div className="flex flex-col w-[100%] justify-center items-center">
                            <span className="text-green-600 font-bold">
                              {t("numadd.equalPriceAll")}
                            </span>
                            <div className="flex flex-row w">
                              <input
                                type="number"
                                value={allbetamt}
                                onClick={(e) => e.target.select()}
                                onChange={(e) => {
                                  handlecal(e);
                                  handlecalbuttonfixprice(e.target.value);
                                }}
                                min="1"
                                className="w-[100%] border-[1px] border-black rounded-l p-1"
                              ></input>
                              <button
                                onClick={handlecalbutton}
                                className="border-[1px] border-green-500 hover:bg-green-700 text-green-600 font-bold py-2 px-4 rounded-r"
                              >
                                +
                              </button>
                            </div>
                          </div>
                          <div className="flex flex-col w-[100%] justify-center items-center">
                            <div className="flex flex-row space-x-2 w-[100%] md:p-3">
                              <button
                                className="p-1 bg-slate-400 border-[1px] border-slate-700 rounded text-center w-[25%]"
                                onClick={() => handlecalbuttonfixprice(5)}
                              >
                                <span className="text-black font-bold">
                                  5 {currency?.symbol}
                                </span>
                              </button>
                              <button
                                onClick={() => handlecalbuttonfixprice(10)}
                                className="p-1 bg-slate-400 border-[1px] border-slate-700 rounded text-center w-[25%]"
                              >
                                <span className="text-black font-bold">
                                  10 {currency?.symbol}
                                </span>
                              </button>
                              <button
                                onClick={() => handlecalbuttonfixprice(20)}
                                className="p-1 bg-slate-400 border-[1px] border-slate-700 rounded text-center w-[25%]"
                              >
                                <span className="text-black font-bold">
                                  20 {currency?.symbol}
                                </span>
                              </button>
                              <button
                                onClick={() => handlecalbuttonfixprice(50)}
                                className="p-1 bg-slate-400 border-[1px] border-slate-700 rounded text-center w-[25%]"
                              >
                                <span className="text-black font-bold">
                                  50 {currency?.symbol}
                                </span>
                              </button>
                            </div>
                            <div className="flex flex-row items-center justify-center space-x-2 w-[100%] md:p-3">
                              <button
                                onClick={() => handlecalbuttonfixprice(100)}
                                className="p-1 bg-slate-400 border-[1px] border-slate-700 rounded text-center w-[100%]"
                              >
                                <span className="text-black font-bold">
                                  100 {currency?.symbol}
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="flex border-black flex-row w-[100%]">
                          <div className="flex flex-col w-[100%] p-1 h-[50px] bg-brand-blue-700 justify-center items-center">
                            <span className="font-bold text-white text-[13px]">
                              {t("numadd.remainingCredit")}
                            </span>
                            <span className="font-bold text-white text-[16px]">
                              {props.balance} {currency?.symbol}
                            </span>
                          </div>
                          <div className="flex flex-col w-[100%] p-1 h-[50px] bg-gradient-to-b from-brand-gold-400 to-brand-gold-600 justify-center items-center">
                            <span className="font-bold text-brand-ink-onGold text-[13px]">
                              {t("numadd.totalBet")}
                            </span>
                            <span className="font-bold text-brand-ink-onGold text-[16px]">
                              {sumWithInitial} {currency?.symbol}
                            </span>
                          </div>
                        </div>

                        <div className="flex border-black  flex-row w-[100%]">
                          <div className="flex flex-col w-[100%] p-1 h-[50px] justify-center items-center">
                            <div className="flex flex-row items-center justify-center space-x-2 w-[100%] p-3">
                              <button
                                onClick={setArrayZe}
                                className="p-1 bg-slate-200 rounded text-center w-[100%] hover:bg-slate-400"
                              >
                                <span className="text-black font-bold">
                                  {t("numadd.cancelAll")}
                                </span>
                              </button>
                            </div>
                          </div>

                          <div className="flex flex-col w-[100%] p-1 h-[50px] justify-center items-center">
                            <button
                              onClick={handleSubmit}
                              className="p-1 rounded text-center w-[100%] bg-gradient-to-b from-brand-gold-300 to-brand-gold-600 hover:from-brand-gold-200 hover:to-brand-gold-500 border border-brand-gold-200 shadow-gold transition-all"
                            >
                              <span className="text-brand-ink-onGold font-bold">
                                {t("numadd.submitOrder")}
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </DialogActions>
                  </Dialog>

                  <StepModal
                    open={!!stepModalCode}
                    stepName={
                      stepModalCode ? codeMeta[stepModalCode]?.name : ""
                    }
                    stake={stepModalCode ? codeMeta[stepModalCode]?.stake : ""}
                    digitCount={
                      stepModalCode ? codeMeta[stepModalCode]?.digit : 0
                    }
                    onClose={() => setStepModalCode(null)}
                    onConfirm={handleStepConfirm}
                  />

                  {/* //////////////////////////////////////// */}
                </div>
                <div className="md:flex-1 md:min-h-0 md:overflow-y-auto">
                  <Lottotype
                    grouparray={garr}
                    codeMeta={codeMeta}
                    handleDelete={handleDelete}
                    handleChange={handleChange}
                  />
                </div>
                <button
                  onClick={handleSubmit}
                  className="p-2 bg-gradient-to-b from-brand-gold-300 to-brand-gold-600 hover:from-brand-gold-200 hover:to-brand-gold-500 border border-brand-gold-200 rounded-lg text-center w-[100%] shadow-gold transition-all"
                >
                  <span className="text-brand-ink-onGold font-bold">
                    {t("numadd.submitOrder")}
                  </span>
                </button>
                <button
                  className="flex items-center justify-center gap-1 bg-gradient-to-r from-rose-600 to-red-700 hover:from-rose-700 hover:to-red-800 p-2 w-[100%] rounded-lg shadow-md transition-colors"
                  onClick={() => setConfirmClear(true)}
                >
                  <DeleteForeverIcon className="text-white" fontSize="small" />
                  <span className="md:inline hidden text-white font-semibold">
                    {t("numadd.clearAllList")}
                  </span>
                </button>
              </div>
            </div>
            <div className="flex flex-col w-[65%] p-1 h-auto md:h-full md:min-h-0 md:overflow-y-auto bg-brand-blue-50">
              <div className="flex flex-row w-[100%] h-[auto] gap-1 px-1 pt-1">
                <div
                  onClick={(e) => setSelecttype("numpad")}
                  value="numpad"
                  className={
                    "cursor-pointer transition-colors " +
                    (selecttype === "numpad"
                      ? "w-[50%] h-[50px] justify-center p-2 items-center text-center rounded-t-lg bg-gradient-to-r from-brand-blue-700 to-brand-blue-900 ring-2 ring-brand-gold-300 shadow-md"
                      : "w-[50%] h-[50px] justify-center p-2 items-center text-center rounded-t-lg bg-brand-blue-100 hover:bg-brand-blue-200")
                  }
                >
                  <span
                    className={
                      "font-bold md:text-lg text-xs " +
                      (selecttype === "numpad"
                        ? "text-brand-gold-200"
                        : "text-brand-blue-700")
                    }
                  >
                    {t("numadd.manualTab")}
                  </span>
                </div>

                <div
                  onClick={(e) => setSelecttype("numlist")}
                  value="numlist"
                  className={
                    "cursor-pointer transition-colors " +
                    (selecttype === "numlist"
                      ? "w-[50%] h-[50px] justify-center p-2 items-center text-center rounded-t-lg bg-gradient-to-r from-brand-blue-700 to-brand-blue-900 ring-2 ring-brand-gold-300 shadow-md"
                      : "w-[50%] h-[50px] justify-center p-2 items-center text-center rounded-t-lg bg-brand-blue-100 hover:bg-brand-blue-200")
                  }
                >
                  <span
                    className={
                      "font-bold md:text-lg text-xs " +
                      (selecttype === "numlist"
                        ? "text-brand-gold-200"
                        : "text-brand-blue-700")
                    }
                  >
                    {t("numadd.panelTab")}
                  </span>
                </div>
              </div>

              {selecttype === "numpad" && (
                <ManualOrder
                  groups={rewardTypeGroups}
                  garr={garr}
                  inputType={inputType}
                  setInputType={setInputType}
                  handleType={handleType}
                  getRate={getRate}
                  betPrice={betPrice}
                  setBetPrice={setBetPrice}
                  number1={number1}
                  number2={number2}
                  number3={number3}
                  number4={number4}
                  number5={number5}
                  number6={number6}
                  numpadvisible={numpadvisible}
                  handleNumpad={handleNumpad}
                  handleCancelLastest={deleteLatestHistory}
                  handleundo={handleundo}
                />
              )}

              {selecttype === "numlist" && (
                <PanelOrder
                  groups={rewardTypeGroups}
                  garr={garr}
                  inputType={inputType}
                  handleType={handleType}
                  getRate={getRate}
                  setInputType={setInputType}
                  firstnumset={firstnumset}
                  numset={numset}
                  secondnumset={secondnumset}
                  numset2={numset2}
                  isNumberSelected={isNumberSelected}
                  handleNumberToggle={handleNumberToggle}
                  handleNumberGroupToggle={handleNumberGroupToggle}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Numadd;
